module.exports = __webpack_public_path__ + "img/nukkit.e9216608.png";